import {
  Box,
  Flex,
  List,
  ListItem,
  Text,
  VStack,
} from "@chakra-ui/react";

const StatBox = ({ label, value }) => (
  <VStack spacing={1}>
    <Text fontSize="14px" color="gray.500">
      {label}
    </Text>
    <Text fontWeight="bold" fontSize="32px">
      {value}
    </Text>
  </VStack>
);





const StatsHeader = ({ stats }) => (
  <Box
    border={"1px solid #E5E9EB"}
    w={"90%"}
    m={"auto"}
    bg="gray.50"
    borderRadius="md"
    p={3}
    mb={4}
  >
    <Text fontSize={"x-large"} fontWeight={500} mb={2}>
      Total Workflows
    </Text>

    <Flex justify="space-between" wrap="wrap" gap={1}>
      <StatBox label="Tokens Consumed" value={stats?.total_tokens} />
      <StatBox label="Sessions" value={stats?.total_session} />
      <StatBox label="Models Used" value={stats?.models_used} />
      <StatBox label="Tools Used" value={stats?.tools_used} />

      <List styleType="disc" color={"#6C7275"} spacing={3} pl={4}>
        <ListItem>
          <Text color={"black"} fontSize="14px" fontWeight="bold">
            {stats?.most_used_model}
          </Text>
          <Text fontSize="10px" color="gray.600">
            Most popular model
          </Text>
        </ListItem>
        <ListItem>
          <Text color={"black"} fontSize="14px" fontWeight="bold">
            {stats?.most_used_tool || "You haven’t added anything yet"}
          </Text>
          <Text fontSize="10px" color="gray.600">
            Most popular tool
          </Text>
        </ListItem>
      </List>
    </Flex>
  </Box>
);

export default StatsHeader;
